<div class="topbar">
  <h1>{{ 'general.allReceipts' | translate }}</h1>
  <section class="right-side">
    <buton techIconRoundButton techButtonColor="danger" (click)="close()">
      <tech-icon>close</tech-icon>
    </buton>
  </section>
</div>
<section class="filter-section">
  <h2>{{ 'general.filters' | translate }}</h2>
  <!-- This all will be the filters of the query  -->
  <div class="filter-wrapper">
    @for (filter of available_filters; track filter) {
      @switch (filter.type) {
        @case ('text') {
          <tech-form-field class="input-item">
            <tech-label>{{ filter.label }}</tech-label>
            <input
              techInput
              [id]="filter.id"
              type="{{ filter.type }}"
              [value]="filter.value ?? ''"
              appTrim
              (keyup.enter)="applyFilters()"
            />
          </tech-form-field>
        }

        @case ('date') {
          <tech-form-field class="input-item">
            <tech-label>{{ filter.label }}</tech-label>
            <input
              techInput
              [id]="filter.id"
              type="{{ filter.type }}"
              [value]="filter.value"
              (keyup.enter)="applyFilters()"
            />
          </tech-form-field>
        }
      }
    }
  </div>
  <button
    class="apply-filters-button"
    techButton
    [disabled]="loading$ | async"
    (click)="applyFilters()"
  >
    {{ 'general.applyFilters' | translate }}
  </button>
  <tech-divider></tech-divider>
</section>
@if (loading$ | async) {
  <div class="loading-spinner">
    <span>Loading permanent storage...</span>
    <tech-loader techLoadingSize="lg"></tech-loader>
  </div>
} @else {
  <section class="table-section">
    <div mat-dialog-content class="table-wrapper">
      <table
        techTable
        [dataSource]="dataSource"
        *techDisplayColumnDef="let columns of displayColumns"
      >
        @for (col of displayColumns; track col) {
          <ng-container techColumnDef="{{ col }}">
            <th tech-header-cell *techHeaderCellDef>
              {{ col.toUpperCase() }}
            </th>
            <td tech-cell *techCellDef="let element">
              {{ formatValue(element[col]) }}
            </td>
          </ng-container>
        }
        <tr tech-header-row *techHeaderRowDef="columns"></tr>
        <tr
          tech-row
          *techRowDef="let row; columns: columns; let odd = even"
          [techDetailRowDef]="row"
          [techRowColor]="'default'"
          [templateRef]="expanded"
          [odd]="odd"
        ></tr>
        <ng-template #expanded let-data>
          <tr
            [techDetailsRow]="data.odd"
            [columns]="columns"
            [techRowColor]="data.color"
          ></tr>
        </ng-template>
      </table>
    </div>
  </section>

  <!-- THIS DOESN'T WORK -->
  <!-- <tech-paginator -->
  <!--   [paginatorData]="paginatorData" -->
  <!--   (change)="newPage($event)" -->
  <!-- ></tech-paginator> -->
}

<section class="paginator">
  <div class="pgnt-text">
    {{ page_size * (current_page - 1) }}-{{
      page_size * (current_page - 1) + page_size
    }}
    of {{ total_query_count }}
  </div>
  <div class="pgnt-buttons">
    <button
      techIconRoundButton
      [disabled]="current_page === 1"
      (click)="numericButtonClick(1)"
    >
      <tech-icon>keyboard_double_arrow_left</tech-icon>
    </button>
    <button
      techIconRoundButton
      [disabled]="current_page === 1"
      (click)="
        numericButtonClick(
          current_page - 5 <= 0 ? (current_page = 1) : current_page - 5
        )
      "
    >
      <tech-icon>more_horiz</tech-icon>
    </button>
    <button
      techIconRoundButton
      [disabled]="current_page === 1"
      (click)="numericButtonClick(current_page - 1)"
    >
      <tech-icon>arrow_back</tech-icon>
    </button>
    @for (i of clickable_pages; track i) {
      <button
        techIconRoundButton
        class="numeric-buttons"
        [disabled]="i > total_pages"
        [class.selected-button]="i === current_page"
        (click)="numericButtonClick(i)"
      >
        {{ i }}
      </button>
    }
    <button
      techIconRoundButton
      (click)="numericButtonClick(current_page + 1)"
      [disabled]="current_page + 1 > total_pages"
    >
      <tech-icon>arrow_forward</tech-icon>
    </button>
    <button
      techIconRoundButton
      (click)="
        numericButtonClick(
          current_page + 5 > total_pages
            ? (current_page = total_pages)
            : current_page + 5
        )
      "
      [disabled]="
        current_page + 1 >= total_pages ||
        (current_page <= 3 && total_pages <= 5)
      "
    >
      <tech-icon>more_horiz</tech-icon>
    </button>
    <button
      techIconRoundButton
      (click)="numericButtonClick(total_pages)"
      [disabled]="current_page >= total_pages"
    >
      <tech-icon>keyboard_double_arrow_right</tech-icon>
    </button>
  </div>
  <div class="pgnt-pagination-size">
    <label>Select page size: </label>
    <select id="page-size-selector" (change)="changePageSize()">
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
      <option value="500">500</option>
    </select>
  </div>
</section>
